const homeConfig = {
  route: '/',
  title: 'Home',
};

export default homeConfig;
